export const ACTIVITY_TYPES = {
  GALLERY_EMAIL_REFERER: 'Pitstop.GalleryEmailReferer',
  PERFORM_GALLERY_SEARCH: 'Pitstop.PerformGallerySearch',
  WRENCH_PRODUCT_VIEW: 'Pitstop.WrenchProductView',
};
